import { ClerkProvider } from '@clerk/clerk-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.js';
import { EnvironmentRibbon } from './components/EnvironmentRibbon.js';
import { FigProvider } from './session/FigProvider.js';
import './theme/tokens.css';
import './index.css';

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined;
if (!publishableKey) {
  // Fail loudly at startup rather than as a confusing sign-in failure later. Checklist E-style
  // fail-fast: a missing key is a deployment mistake, not a user's problem.
  throw new Error('VITE_CLERK_PUBLISHABLE_KEY is not set. Copy .env.example to .env.');
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {/*
      OUTSIDE every provider and the router, deliberately. The ribbon must be visible on the
      sign-in screen, on an error boundary, and while the session is still resolving - which are
      exactly the moments somebody is most likely to be confused about which portal they are in.
      Anything rendered inside FigProvider is absent until a session exists.
    */}
    <EnvironmentRibbon />
    <ClerkProvider publishableKey={publishableKey} afterSignOutUrl="/sign-in">
      <BrowserRouter>
        <FigProvider>
          <App />
        </FigProvider>
      </BrowserRouter>
    </ClerkProvider>
  </StrictMode>,
);
